<template>
  <search-group title="密码查询" @clear="clearValue" @search="findData" :inline="true" :multipleLines="true" :btnOffset="18" :btnSpan="6"  :span="24">
    <Row :gutter="24" class="mb16">
      <Col span="6">
        <Select placeholder="项目名称" v-model="searchData.projectId">
          <Option value="">请选择</Option>
          <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <Select placeholder="密码类型" v-model="searchData.pwdType">
          <Option value="">请选择</Option>
          <Option v-for="item in pwdTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="5">
        <Select placeholder="密码状态" v-model="searchData.pwdStatus">
          <Option value="">请选择</Option>
          <Option v-for="item in pwdStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Input placeholder="房间号查询" v-model="searchData.roomNumber" @keyup.enter.native="findData"/>
      </Col>
      <Col span="4">
        <Input placeholder="操作人" v-model="searchData.handlerName" @keyup.enter.native="findData"/>
      </Col>
    </Row>
    <Row   :gutter="24">
      <Col span="6">
        <Select placeholder="使用人类型" v-model="searchData.userType">
          <Option value="">请选择</Option>
          <Option v-for="item in userTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="6">
        <DatePicker type="datetimerange" placeholder="请选择创建时间范围" v-model="startDateTime"
                    style="display: block"></DatePicker>
      </Col>
      <Col span="6">
        <DatePicker type="datetimerange" placeholder="请选择失效时间范围" v-model="endDateTime"
                    style="display: block"></DatePicker>
      </Col>
    </Row>



  </search-group>
</template>

<script>
  import SearchGroup from 'components/SearchGroup/index';
  import FormItem from "../../../basicData/suppliers/components/FormItem";
  import { formatDateTime } from "@/utils/format";

  export default {
    name: "SearchList",
    components: {
      FormItem,
      SearchGroup
    },
    props: {
      projectList: {
        type: Array,
        default: null
      },
      pwdTypeList: {
        type: Array,
        default: null,
      },
      userTypeList: {
        type: Array,
        default: null
      },
      pwdStatusList: {
        type: Array,
        default: null
      },
      setDefault:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        searchData: {
          projectId: '',
          roomNumber: '',
          handlerName: '',
          pwdType: '',
          pwdStatus: '',
          userType: '',
          page: 1,
          limit: 10

        },
        createTime: ['00:00:00', '23:59:59'],
        invalidTime: ['00:00:00', '23:59:59'],
        createDate: '',
        invalidDate: '',
        startDateTime:[],
        endDateTime:[]
      }
    },
    watch:{
      setDefault(value){
        value==true&&(this.searchData.projectId=this.projectList[0].value)
      }
    },
    methods: {
      formatDate(str){
        if(!str){
          return ''
        }
        return formatDateTime(str)
      },
      initDate(){
        let date = new Date()
        let month = date.getMonth() + 1
        let day = date.getDate()
        let month2 = month.toString().length == 1 ? ('0' + month) : month
        let add = date.getFullYear() + '-' + month2 + '-' + day + ' '
        this.startDateTime=[add+'00:00:00',add+'23:59:59']
        this.endDateTime=[add+'00:00:00',add+'23:59:59']
      },
      clearValue() {
        this.searchData = {
          projectId: '',
          roomNumber: '',
          handlerName: '',
          pwdType: '',
          pwdStatus: '',
          userType: '',
          page: 1,
          limit: 10
        }
      },
      findData() {
        if (this.searchData.projectId == '') {
          this.$Message.info('请选择项目')
          return
        }
        let params = Object.assign({}, this.searchData)
        params['createStartTime'] = this.formatDate(this.startDateTime[0])
        params['createEndTime'] = this.formatDate(this.startDateTime[1])
        params['invalidStartTime'] =this.formatDate(this.endDateTime[0])
        params['invalidEndTime'] = this.formatDate(this.endDateTime[1])
        this.$emit('findData', params)
      }
    },
    created(){
      this.initDate()
    }
  }
</script>

<style scoped>
  .text-style {
    text-align: center;
    line-height: 32px
  }

  .mb25 {
    margin-bottom: 25px;
  }
  .text-center{
    text-align: center;
  }

</style>
